"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const rootNavigation_1 = require("../../navigators/rootNavigation");
const Routes_1 = __importDefault(require("../../navigators/Routes"));
const helpler_1 = require("../../utils/helpler");
const RenderText = ({ text, style = {} }) => {
    return (react_1.default.createElement(react_native_1.Text, { style: style }, text?.split(helpler_1.hashtagRegex).map((string, index) => {
        if (string.match(helpler_1.hashtagRegex)) {
            return (react_1.default.createElement(react_native_1.Text, { key: index, style: { color: "#007AFF" }, onPress: () => {
                    (0, rootNavigation_1.navigate)(Routes_1.default.HIDDEN_TAB_NAVIGATOR, {
                        screen: Routes_1.default.HASHTAG_DETAIL,
                        params: {
                            hagTag: string,
                            type: 0
                        },
                    });
                } }, string));
        }
        else {
            return react_1.default.createElement(react_native_1.Text, { key: index }, string);
        }
    })));
};
exports.default = RenderText;
